import React, { FC, useState } from 'react';
import { EditorPlatformI18nProvider } from '../providers/EditorPlatformI18nProvider';
import { WixDesignSystemProvider } from '@wix/design-system';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { ExperimentsBag } from '@wix/wix-experiments';
import {
  DeleteAppModalContainer,
  DeleteAppModalProps,
} from './DeleteAppModalContainer/DeleteAppModalContainer';
import { DeleteAppOriginSource } from './DeleteAppModalContainer/constants';

type DeleteAppModalPropsWithTranslations = DeleteAppModalProps & {
  locale: string;
  experiments?: ExperimentsBag;
};

export const DeleteAppModal: FC<DeleteAppModalPropsWithTranslations> = ({
  locale,
  experiments,
  ...props
}: DeleteAppModalPropsWithTranslations) => {
  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <EditorPlatformI18nProvider locale={locale}>
        <ExperimentsProvider options={{ experiments }}>
          <DeleteAppModalContainer {...props} />
        </ExperimentsProvider>
      </EditorPlatformI18nProvider>
    </WixDesignSystemProvider>
  );
};

export { DeleteAppOriginSource };
